/** @jsxImportSource @emotion/react */

import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { FullRiskSummary } from '@app/components/Molecules/FullRiskSummary'
import { Tab, Tabs } from '@app/components/Molecules/Tabs'
import apiClient from '@app/config/axios.config'
import { lazy, useCallback, useEffect, useState } from 'react'
import { SummaryPageContainer } from './SummaryPage.styles'

const UiMarkdown = lazy(() => import('@app/components/Atoms/UiMarkdown/UiMarkdown'))

export const SummaryPage = () => {
  const theme = useTheme()
  const clientName = localStorage.getItem('client_name')
  const [pageContent, setPageContent] = useState<{ section: string; content: string }[]>([])
  const [tabs, setTabs] = useState<Tab[]>([])

  useEffect(() => {
    if (!clientName) return
    const abortController = new AbortController()
    const fetchRegions = async () => {
      try {
        const response = await apiClient.get(`/content/summaryPage`, {
          signal: abortController.signal,
        })

        setPageContent(response.data)
      } catch {
        setPageContent([])
      }
    }
    fetchRegions()
    return () => {
      abortController.abort()
    }
  }, [clientName])

  const renderTabContent = useCallback((content: string) => {
    return <UiMarkdown>{content}</UiMarkdown>
  }, [])

  useEffect(() => {
    if (!pageContent) return
    const newTabs: Tab[] = pageContent.map((item) => ({
      label: item.section,
      value: item.section,
      content: renderTabContent(item.content),
    }))
    newTabs.push({
      label: 'Risk Summary',
      content: <FullRiskSummary />,
    })
    setTabs(newTabs)
  }, [pageContent, renderTabContent])

  return (
    <Box css={SummaryPageContainer({ theme })}>
      {tabs.length > 1 ? <Tabs tabs={tabs} /> : tabs[0]?.content}
    </Box>
  )
}
